<template>
  <AppModal
    :heading="isEditing ? 'Edit Address' : 'Add New Address'"
    @close="closeModal"
  >
    <template slot="content">
      <ValidationObserver ref="formObserver" v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(onSubmit)">
          <div class="md:flex">
            <div class="pb-5 md:w-1/2 md:pr-5">
              <input
                class="form-input"
                placeholder="Flat Number(optional)"
                name="Flat Number"
                v-model="formData.flat_no"
              >
            </div>
            <div class="pb-5 md:w-1/2 md:pl-5">
              <input
                class="form-input"
                placeholder="Floor Number(optional)"
                name="Floor Number"
                v-model="formData.floor_no"
              >
            </div>
          </div>
          <div class="md:flex">
            <div class="pb-5 md:w-1/2 md:pr-5">
              <input
                class="form-input"
                placeholder="Building Name(optional)"
                name="Building Name"
                v-model="formData.building_name"
              >
            </div>
            <ValidationProvider v-slot="{ errors }" rules="required" class="md:w-1/2 md:pl-5">
              <input
                class="form-input"
                type="text"
                placeholder="Full Name"
                name="Full Name"
                v-model="formData.full_name"
              >
              <div class="input-error">{{ errors[0] }}</div>
            </ValidationProvider>
          </div>
          <div class="md:flex">
            <ValidationProvider
              v-slot="{ errors }"
              class="md:w-1/2 md:pr-5"
              rules="required"
            >
              <input
                class="form-input"
                type="text"
                placeholder="Address Line 1"
                name="Address Line 1"
                v-model="formData.address_line1"
              >
              <div class="input-error">{{ errors[0] }}</div>
            </ValidationProvider>
            <div class="pb-5 md:w-1/2 md:pl-5">
              <input
                class="form-input"
                placeholder="Address Line 2(optional)"
                name="Address Line 2"
                v-model="formData.address_line2"
              >
            </div>
          </div>
          <div class="md:flex">
            <ValidationProvider v-slot="{ errors }" class="md:w-1/2 md:pr-5" rules="required">
              <input
                class="form-input"
                type="text"
                placeholder="City"
                name="City"
                v-model="formData.city"
              >
              <div class="input-error">{{ errors[0] }}</div>
            </ValidationProvider>
            <ValidationProvider
              v-slot="{ errors }"
              class="md:w-1/2 md:pl-5"
              rules="required"
              name="Country/Region"
            >
              <country-select
                v-model="formData.country"
                :country="formData.country"
                topCountry="US"
                placeholder="Country/Region"
                class="form-input focus:text-opacity-100"
                name="Country"
                :class="{'text-dark text-opacity-50': !formData.country}"
                ref="countrySelect"
              />
              <div class="input-error">{{ errors[0] }}</div>
            </ValidationProvider>
          </div>
          <div class="md:flex">
            <ValidationProvider
              v-slot="{ errors }"
              class="md:w-1/2 md:pr-5"
              rules="required"
              name="Province/State"
            >
              <region-select
                v-model="formData.region"
                :country="formData.country"
                :region="formData.region"
                placeholder="Province/State"
                class="form-input focus:text-opacity-100"
                :class="{'text-dark text-opacity-50': !formData.country}"
              />
              <div class="input-error">{{ errors[0] }}</div>
            </ValidationProvider>
            <ValidationProvider
              v-slot="{ errors }"
              class="md:w-1/2 md:pl-5"
              rules="required"
            >
              <input
                class="form-input"
                type="text"
                placeholder="Post Code"
                name="Post Code"
                v-model="formData.postcode"
              >
              <div class="input-error">{{ errors[0] }}</div>
            </ValidationProvider>
          </div>
          <div class="md:flex">
            <ValidationProvider
              v-slot="{ errors }"
              class="md:w-1/2 md:pr-5"
              rules="required"
            >
              <input
                class="form-input"
                type="number"
                @keypress="isNumber($event)"
                placeholder="Phone Number"
                name="Phone Number"
                v-model="formData.phone_number"
              >
              <div class="input-error">{{ errors[0] }}</div>
            </ValidationProvider>
            <ValidationProvider
              v-slot="{ errors }"
              class="md:w-1/2 md:pl-5"
              rules="required"
            >
              <select
                class="form-input focus:text-opacity-100"
                v-model="formData.alias"
                name="Account Type"
                :class="{'text-dark text-opacity-50': !formData.alias}"
              >
                <option value="" disabled>Address Type</option>
                <option value="Home">Home</option>
                <option value="Office">Office</option>
                <option value="Warehouse">Warehouse</option>
                <option value="Other">Other</option>
              </select>
              <div class="input-error">{{ errors[0] }}</div>
            </ValidationProvider>
          </div>
          <button class="new-app-btn bg-blue">{{ buttonText }}</button>
        </form>
      </ValidationObserver>
    </template>
  </AppModal>
</template>
<script>
import { mapActions } from 'vuex'

export default {
  name: 'AddressFormModal',
  props: {
    address: {
      type: Object
    },
    isEditing: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      formData: {
        floor_no: '',
        flat_no: '',
        building_name: '',
        full_name: '',
        address_line1: '',
        address_line2: '',
        country: '',
        city: '',
        region: '',
        postcode: '',
        phone_number: '',
        alias: ''
      },
      showCountryError: false,
      submitted: false
    }
  },
  created() {
    if (this.isEditing) {
      this.formData = this.address
    }
  },
  mounted() {
    const options = this.$refs.countrySelect.$el
    const tw = options.querySelector('[value="TW"]')
    const hk = options.querySelector('[value="HK"]')
    tw.innerHTML = 'Taiwan R.O.C'
    hk.innerHTML = 'HongKong S.A.R'
  },
  computed: {
    buttonText() {
      return this.isEditing ? 'Update' : 'Save'
    }
  },
  methods: {
    ...mapActions ([
      'addBuyerAddress',
      'updateBuyerAddress'
    ]),
    
    closeModal(data) {
      this.$emit('close', data)
    },
    isNumber: function(evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    async onSubmit() {
      const data = this.isEditing
        ? await this.updateBuyerAddress(this.formData)
        : await this.addBuyerAddress(this.formData)
      if (data.result) {
        const message = this.isEditing ? 'Address Updated!' : 'Address Saved!'
        if(this.isEditing == false) {
          this.$emit('selectNewAddress',data.address.id_token);
        } else {
          this.$emit('selectNewAddress',this.formData.id_token);
        }
        this.$notify({
          group: 'buyHive',
          type: 'success',
          text: message,
          duration: 7000
        })
        this.closeModal(true)
      } else {
        this.$notify({
          group: 'buyHive',
          type: 'error',
          text: data.message,
          duration: 7000
        })
      }
    }
  }
}
</script>
